import 'core-js/modules/es.array.flat-map.js';
import 'core-js/modules/es.array.unscopables.flat-map.js';

class GetPostPagination {
  execute({
    postId,
    sections
  }) {
    if (!sections || !postId) {
      return {
        previous: null,
        next: null
      };
    }
    let previousPostId = null;
    let nextPostId = null;
    // Map all posts to a single array
    const allPosts = sections.flatMap(item => item.posts);
    // Find the index of the post with the given postId
    const postIndex = allPosts.findIndex(post => post.id === postId);
    // Check if there's a previous post
    if (postIndex > 0) {
      previousPostId = allPosts[postIndex - 1].id;
    }
    // Check if there's a next post
    if (postIndex < allPosts.length - 1) {
      nextPostId = allPosts[postIndex + 1].id;
    }
    return {
      previous: previousPostId,
      next: nextPostId
    };
  }
}

export { GetPostPagination };
